import Icon from '../components/Icon.vue'

Icon.register({"fire":{"width":384,"height":512,"paths":[{"d":"M216 23.9C216 0.1 185.3-8.9 171.9 10.8 48 191.9 224 200 224 288 224 323.6 194.9 352.5 159.2 352 124 351.5 96 322.2 96 287V201.5C96 179.8 69.5 169.3 54.6 185 27.8 213.2 0 261.3 0 320 0 425.9 86.1 512 192 512S384 425.9 384 320C384 149.7 216 127 216 23.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/fire.js
// module id = null
// module chunks = 